import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function NoRtkQueryApi() {
    return (_jsxs("div", { css: (theme) => ({
            width: '100%',
            textAlign: 'center',
            color: theme.TEXT_COLOR,
            padding: '1.4em',
            '& a': {
                fontSize: 'inherit',
                color: theme.TEXT_COLOR,
                textDecoration: 'underline',
            },
        }), children: ["No rtk-query api found.", _jsx("br", {}), "Make sure to follow", ' ', _jsx("a", { href: "https://redux-toolkit.js.org/rtk-query/overview#basic-usage", target: "_blank", rel: "noreferrer noopener", children: "the instructions" }), "."] }));
}
